import { lazy } from 'react'

export const ARTICLE_REGISTRY = {
  'how-terraplanner-made-tracking-my-gardening-easier': lazy(() =>
    import('./how-terraplanner-made-tracking-my-gardening-easier')
  ),
  'grow-your-own-food-groceries-are-too-expensive': lazy(() =>
    import('./grow-your-own-food-groceries-are-too-expensive')
  ),
}
